import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-home-widget',
    templateUrl: './home-widget.component.html',
    styleUrls: ['./home-widget.component.scss'],
    standalone: false
})
export class HomeWidgetComponent {
    @Input() height = '100%';
}
